import { useContext } from "preact/hooks";
import { Icon } from "../ui/icon";
import { EditContext } from "./edits";
import { interpolate, type Labels } from "./labels";
import { useOpenPopup } from "./popups";

const FRAME = "h-full w-full rounded-xl border-2 border-surface-raised shadow-md";

// The header's portrait. For a viewer who may edit and a sheet that has the picker, it is a button that opens it, with a "Trocar" band
// over the picture while the mouse is on it or it has keyboard focus (never on a screen with no hover); everyone else sees the picture alone.
export function PortraitBox({ url, name, labels, picker }: { url: string | null; name: string; labels: Labels; picker: boolean }) {
	const open = useOpenPopup();
	const edits = useContext(EditContext);
	const picture = url ? (
		<img class={`${FRAME} object-cover object-top`} src={url} alt={interpolate(labels.header.portrait_alt, { name })} />
	) : (
		<div class={`${FRAME} flex items-center justify-center bg-surface-sunken text-ink-muted`}>
			<Icon name="pawn" class="h-1/2 w-1/2" />
		</div>
	);
	if (!(picker && edits && open)) return <div class="cs-portrait">{picture}</div>;
	return (
		<button
			type="button"
			class="cs-portrait group relative block cursor-pointer overflow-hidden rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-carmesim-600"
			aria-label={labels.portrait.change}
			onClick={(event) => open({ kind: "portrait" }, event.currentTarget)}
		>
			{picture}
			<span class="absolute inset-x-0.5 bottom-0.5 flex items-center justify-center gap-1 rounded-b-[10px] bg-grafite-900/75 py-0.5 text-[11px] font-bold text-white opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 [@media(hover:none)]:hidden">
				<Icon name="pen" class="h-3 w-3" />
				{labels.portrait.swap}
			</span>
		</button>
	);
}
